var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResidential(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#9D0584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-120v-560h160v-160h400v320h160v400H520v-160h-80v160H120Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 320h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h80v-80h-80v80Zm0-160h80v-80h-80v80Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidential);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjOUQwNTg0Ij48cGF0aCBkPSJNMTIwLTEyMHYtNTYwaDE2MHYtMTYwaDQwMHYzMjBoMTYwdjQwMEg1MjB2LTE2MGgtODB2MTYwSDEyMFptODAtODBoODB2LTgwaC04MHY4MFptMC0xNjBoODB2LTgwaC04MHY4MFptMC0xNjBoODB2LTgwaC04MHY4MFptMTYwIDE2MGg4MHYtODBoLTgwdjgwWm0wLTE2MGg4MHYtODBoLTgwdjgwWm0wLTE2MGg4MHYtODBoLTgwdjgwWm0xNjAgMzIwaDgwdi04MGgtODB2ODBabTAtMTYwaDgwdi04MGgtODB2ODBabTAtMTYwaDgwdi04MGgtODB2ODBabTE2MCA0ODBoODB2LTgwaC04MHY4MFptMC0xNjBoODB2LTgwaC04MHY4MFoiLz48L3N2Zz4=";
export { ForwardRef as ReactComponent };